<template>
    <v-dialog v-model="isOpened" width="600px">
        <v-card>
            <v-card-title>
                <span class="headline">Информация о событие</span>
            </v-card-title>
            <v-card-text>
                <div class="mb-2">
                    <p class="text-field-header mb-0">Поля запроса:</p>
                    <div class="info-box" style="white-space: pre-wrap;">{{ req }}</div>
                </div>

                <div class="mb-2">
                    <p class="text-field-header mb-0">Аргументы:</p>
                    <div class="info-box" style="white-space: pre-wrap;">{{ args }}</div>
                </div>

                <div class="mb-2">
                    <p class="text-field-header mb-0">UTM метки:</p>
                    <div class="info-box" style="white-space: pre-wrap;">{{ utms }}</div>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="closeModal()">Закрыть</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "EventDetailModal",
    data() {
        return {};
    },
    computed: {
        isOpened: {
            get() {
                return this.$store.getters.EVENT_INFO_MODAL_OPENED;
            },
            set(val) {
                if (val === false) this.$store.dispatch("CLOSE_EVENT_DETAIL_MODAL");
            },
        },
        event() {
            return this.$store.getters.EVENT_INFO_ITEM;
        },
        utms() {
            return JSON.stringify(this.event.utms, null, 4);
        },
        req() {
            return JSON.stringify(this.event.request, null, 4);
        },
        args() {
            return JSON.stringify(this.event.args, null, 4);
        },
    },
    methods: {
        closeModal() {
            this.$store.dispatch("CLOSE_EVENT_DETAIL_MODAL");
        },
    },
};
</script>
